export default __webpack_public_path__ + "static/hitech-int-op-e720fab89d26e9991825ef94618e4a13.png";